export default __webpack_public_path__ + "static/media/o1.7605b6ef.jpg";